import React from 'react';
import { HomeInfoCard } from './HomeInfoCard';

interface Props { isDark: boolean; onOpen: () => void }

export const GuestAgapellaInvite: React.FC<Props> = ({ isDark, onOpen }) => (
  <HomeInfoCard
    testID="guest-agapella-invite"
    ctaTestID="guest-agapella-open"
    kind="assistant"
    title="Спроси Агапеллу"
    body="Она знает платформу изнутри и подскажет, с чего начать — можно поговорить прямо сейчас, без регистрации."
    cta="Начать разговор"
    onPress={onOpen}
    isDark={isDark}
  />
);
